import { render, staticRenderFns } from "./AutoMailerReports.vue?vue&type=template&id=584cee66&scoped=true"
import script from "./AutoMailerReports.vue?vue&type=script&lang=js"
export * from "./AutoMailerReports.vue?vue&type=script&lang=js"
import style0 from "./AutoMailerReports.vue?vue&type=style&index=0&id=584cee66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cee66",
  null
  
)

export default component.exports